import styled from 'styled-components';
import {
  tablet_landscape_breakpoint,
  tablet_portrait_breakpoint,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths';

export const ClaytonEmployeeCANoticeStyles = styled.div`
  padding: 0 20px;
  .clayton-employee-ca-notice-collection-content {
    margin-top: 50px;
    @media screen and (min-width: ${tablet_landscape_breakpoint}px) {
      margin: 0 auto;
      max-width: 996px;
      padding-top: 85px;
    }
    h1,
    h3 {
      font-family: 'acumin-pro', sans-serif;
      margin: 20px auto 10px;
      text-transform: uppercase;
    }
    p {
      color: #4e5255;
      font-family: 'source-sans-pro', sans-serif;
      font-size: 14px;
      line-height: 1.15;
      margin-bottom: 10px;
    }
    h1 {
      font-size: 36px;
      letter-spacing: -0.3px;
      line-height: 1.18;
      @media screen and (min-width: ${tablet_portrait_breakpoint}px) {
        font-size: 40px;
        letter-spacing: 0.35px;
        line-height: 1.2;
      }
    }
    h3 {
      font-size: 22px;
      letter-spacing: -0.35px;
      line-height: 1.18;
      @media screen {
        font-size: 25px;
        line-height: 1.2;
      }
    }
    h4 {
      font-size: 18px;
    }
    h5 {
      font-family: 'source-sans-pro', sans-serif;
      font-size: 16px;
      font-style: italic;
      font-weight: 600;
      letter-spacing: -0.3px;
      line-height: 1.25;
      margin: 20px auto 10px;
      text-decoration: underline;
    }
    .centered-header {
      text-align: center;
    }
    ul {
      padding-left: 20px;
    }
    li {
      color: #4e5255;
      font-family: 'source-sans-pro', sans-serif;
      font-size: 14px;
      line-height: 1.15;
      margin-bottom: 10px;
    }
    table,
    th,
    td {
      border: 1px solid black;
      border-collapse: collapse;
    }
    table {
      margin-bottom: 10px;
      tr {
        td {
          padding: 10px 10px 0;
          vertical-align: top;
        }
      }
      .month-heading {
        margin-top: 25px;
      }
    }
    @media screen and (max-width: ${desktop_breakpoint}px) {
      table,
      td,
      th {
        display: block;
        border: none;
        float: left;
      }
      table {
        width: 100%;
        border-bottom: 1px solid #cecece;
        margin-bottom: 25px;
        tr {
          display: flex;
          flex-direction: column;
          .categories-personal-info-content {
            order: 1;
          }
          .do-we-collect-content {
            order: 2;
          }
          .purposes-collection-content {
            order: 3;
          }
          .retention-policy-content {
            order: 4;
          }
        }

        td {
          text-align: left;
        }
      }
      .do-we-collect-heading,
      .purposes-collection-heading,
      .retention-policy-heading {
        display: none;
      }
      .do-we-collect-content {
        border-bottom: 1px solid #bdbdbd;
        padding-left: 150px;
        input {
          &:before {
            content: 'Do We collect?';
            font-weight: 700;
            position: absolute;
            left: 30px;
            margin-top: -2px;
          }
        }
      }
      .purposes-collection-content {
        ul {
          border-bottom: 1px solid #bdbdbd;
          li:first-of-type {
            padding-top: 15px;
          }
          &:before {
            content: 'Purposes for Collection';
            display: flex;
            font-family: 'acumin-pro', sans-serif;
            font-size: 18px;
            font-weight: bold;
            justify-content: center;
            letter-spacing: -0.3px;
            line-height: 1.22;
          }
        }
      }
      .retention-policy-content {
        &:before {
          content: 'Retention Policy';
          display: flex;
          font-family: 'acumin-pro', sans-serif;
          font-size: 18px;
          font-weight: bold;
          justify-content: center;
          letter-spacing: -0.3px;
          line-height: 1.22;
          text-align: center;
        }
        p {
          padding-top: 10px;
        }
      }
      .month-heading,
      .collected-heading,
      .disclosed-heading,
      .disclosure-heading,
      .third-party-heading {
        display: none;
      }
      .collected-content {
        padding-left: 150px;
        input {
          &:before {
            content: 'Collected';
            font-weight: 700;
            position: absolute;
            left: 30px;
            margin-top: -2px;
          }
        }
      }
      .disclosed-content {
        border-bottom: 1px solid #bdbdbd;
        padding-left: 150px;
        input {
          &:before {
            content: 'Disclosed';
            font-weight: 700;
            position: absolute;
            left: 30px;
            margin-top: -2px;
          }
        }
      }
      .disclosure-content {
        ul {
          border-bottom: 1px solid #bdbdbd;
          li:first-of-type {
            padding-top: 15px;
          }
        }
        &:before {
          content: 'Business or Commercial Purpose for Collection & Disclosure';
          display: flex;
          font-family: 'acumin-pro', sans-serif;
          font-size: 18px;
          font-weight: bold;
          justify-content: center;
          letter-spacing: -0.3px;
          line-height: 1.22;
          text-align: center;
        }
      }
      .third-party-content {
        ul {
          li:first-of-type {
            padding-top: 15px;
          }
        }
        &:before {
          content: 'Categories of third parties to whom the information was disclosed';
          display: flex;
          font-family: 'acumin-pro', sans-serif;
          font-size: 18px;
          font-weight: bold;
          justify-content: center;
          letter-spacing: -0.3px;
          line-height: 1.22;
          text-align: center;
        }
      }
    }
  }
`;

export default ClaytonEmployeeCANoticeStyles;
